import Button from "@commons/Button";
import TextInput from "@commons/Input/Text";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import Cookies from "js-cookie";
import { useCallback, useState } from "react";
import { signInWithPassword } from "@services/auth";
import { useUser } from "@hooks/useUser";
import { AppError } from "@utils/errors/appError";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { paths } from "@/paths";
import { Dialog, DialogActions, DialogContent } from "@mui/material";
import Heading from "@commons/Typography/Heading";

const loginSchema = z.object({
  email: z.email("Email inválido"),
  password: z.string().min(8, "A senha deve ter pelo menos 8 caracteres"),
});

type loginSchemaFormData = z.infer<typeof loginSchema>;

function LoginForm() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(loginSchema),
  });

  const { checkSession, saveUser } = useUser();
  const [openModal, setOpenModal] = useState(false);

  const navigate = useNavigate();

  const onSubmit = useCallback(
    async (values: loginSchemaFormData): Promise<void> => {
      try {
        const userAuth = await signInWithPassword(values);
        if (userAuth) {
          Cookies.set("x_access_token", userAuth.accessToken);
          await saveUser(userAuth.user);
          await checkSession?.();
          toast.success("Login realizado com sucesso!");
          navigate(paths.home, { replace: true });
        }
      } catch (error) {
        const isAppError = error instanceof AppError;

        const title = isAppError
          ? error.message
          : "Erro ao fazer login! Tente novamente!";
        toast.error(title);
      }
    },
    [checkSession, saveUser, navigate],
  );

  return (
    <>
      <form
        className="space-y-4 w-full flex flex-col"
        onSubmit={handleSubmit(onSubmit)}
      >
        <TextInput
          label="Email"
          type="email"
          placeholder="Digite seu email"
          textSize="md"
          className="rounded-full"
          fullWidth
          autoComplete="email"
          {...register("email")}
          error={!!errors.email}
          helperText={errors.email?.message}
        />
        <TextInput
          label="Senha"
          type="password"
          placeholder="Digite sua senha"
          textSize="md"
          className="rounded-full"
          autoComplete="current-password"
          fullWidth
          {...register("password")}
          error={!!errors.password}
          helperText={errors.password?.message}
        />

        <Button customVariant="secondary" size="full" type="submit">
          Entrar
        </Button>
        <Button
          customVariant="ghost"
          size="full"
          type="button"
          onClick={() => setOpenModal(true)}
        >
          Esqueceu sua senha?
        </Button>
      </form>
      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        maxWidth="xs"
      >
        <DialogContent className="text-center py-6 px-6">
          <Heading size="sm" className="mb-4">
            CONTATE O ADMINISTRADOR
          </Heading>
          <DialogActions className="justify-center">
            <Button
              customVariant="primary"
              size="full"
              onClick={() => setOpenModal(false)}
            >
              OK
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </>
  );
}
export default LoginForm;
